module.exports = __webpack_public_path__ + "media/photo/management-9ef4dc07.jpg";